import React from "react";
import Input from "./Input";
import OtpInput from "react-otp-input";
import PrimaryTheme from "../Themes/Primary";
import "./withdrawComission.scss";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import StatusAlert from "./StatusAlert";
import Lock from "../images/lock.svg";
import { useSelector } from "react-redux";
import { Reducers } from "../Interfaces/Interfaces";

export default function WithdrawalAuthentication(props: any) {
  const modalAlert = useSelector((state: Reducers) => state.modalAlert);

  React.useEffect(() => {
    props.setLoadingCommissionCashout(false)

    props.counter > 0 &&
      setTimeout(() => props.setCounter(props.counter - 1), 800);
  }, [props.counter]);

  // React.useEffect(() => {

  //     if (!modalAlert) {
  //         console.log('got here');
  //         props.setAuthenticate(false)
  //     }
  // }, [modalAlert]);

  return (
    <div className="col-md-12 modal-container">
      <DialogContent>
        <div style={{ textAlign: "center", marginBottom: "15px" }}>
          <img src={Lock} />
        </div>
        <div className="row m-0 justify-content-center align-items-center">
          <div className="justify-content-center align-items-center">
            <div
              style={{
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "21px",
                lineHeight: "25px",
                textAlign: "center",
                color: "#3D4355",
                marginBottom: "15px",
              }}
            >
              2FA Protection
            </div>
            <div
              style={{
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "140%",
                textAlign: "center",
                color: "#313131",
                marginBottom: "30px",
              }}
            >
              We have sent OTP codes to your <br></br> registered phone number.
            </div>
          </div>

          <OtpInput
            value={props.otp}
            onChange={(e: any) => props.setOtp(e)}
            numInputs={6}
            isInputNum
            shouldAutoFocus
            inputStyle={{
              width: "45px",
              height: "45px",
              fontSize: "24px",
              padding: 0,
              textAlign: "center",
              borderRadius: 10,
              border: "1px solid",
              borderColor: PrimaryTheme.primary,
            }}
            isInputSecure
            separator={<span className="mr-3"> </span>}
          />
        </div>
      </DialogContent>

      <div
        style={{
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "15px",
          lineHeight: "150%",
          textAlign: "center",
          color: "#313131",
          marginBottom: "25px",
          marginTop: "37px",
        }}
      >
        Didn't receive OTP?
        <span
          style={{
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "15px",
            lineHeight: "150%",
            textAlign: "center",
            color: "#296CF0",
            paddingLeft: "5px",
          }}
        >
          {props.counter > 0 && <span>Resend in {props.counter}</span>}
          {props.counter == 0 && (
            <span onClick={props.handleBank} style={{ cursor: "pointer" }}>
              Resend
            </span>
          )}
        </span>
      </div>

      <DialogActions>
        <div className="col-md-8 ml-auto mr-auto mb-0 text-center pb-4">
          <Input
            type="button"
            isInput
            id="confirm-password"
            value={props.submitted ? "Verifying..." : "Continue"}
            disabled={props.submitted}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: "1.1rem",
              borderRadius: 100,
            }}
            onClick={props.handleSubmit}
          />
        </div>
      </DialogActions>

      <StatusAlert
        title={props.title}
        subtitle={props.subtitle}
        buttonTitle={"Close"}
        onClick={props.handleRefresh}
      ></StatusAlert>
    </div>
  );
}
